import ReactECharts from "echarts-for-react";

export default function AttendanceBars({ events }) {
  if (!events || events.length === 0) return null;
  events = events.sort((a, b) => new Date(a.checkInTimeUTC) - new Date(b.checkInTimeUTC))
  const hours = events.map(e => (e.minutesWorked || 0) / 60);

  const option = {
    tooltip: {
      trigger: "axis",
      appendToBody: true,
      backgroundColor: "#1f2937",
      borderColor: "#374151",
      textStyle: { color: "#fff" },
      axisPointer: { type: "shadow" },

      formatter: function (params) {
        const i = params[0].dataIndex;
        const e = events[i];
        const hoursWorked = ((e.minutesWorked || 0) / 60).toFixed(2);

        return `
          <b>${e.DateTimeLocal} - ${e.DateTimeLocalOut}</b><br/>
          Hours Worked: ${hoursWorked}<br/>
          Shift: ${e.shift?.name || "N/A"}
        `;
      }
    },

    grid: { left: 0, right: 0, top: 5, bottom: 5 },

    xAxis: {
      type: "category",
      show: true,
      data: events.map(e => '')
    },

    yAxis: {
      type: "value",
      show: false
    },

    series: [
      {
        type: "bar",
        data: hours,
        barWidth: 6,
        itemStyle: {
          color: "white"
        }
      }
    ]
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 40, width: 120 }}
      opts={{ renderer: "svg" }}
    />
  );
}